import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: null }),
  cmsModifierId: belongsTo('user', { inverse: null }),
  scanner: belongsTo('a11y-scanner', { inverse: null }),
});
